/**
 * Extracts a plain string status name from the raw `atlassian:state` JSON-LD
 * field, which can appear in several forms:
 *
 *   - a bare string          e.g. "open", "merged", "draft"
 *   - an Object with .name  e.g. { "@type": "Object", "name": "In Progress" }
 *
 * Returns undefined when the field is absent or carries no usable name.
 * Applies to Document, SourceCodePullRequest, Project, and Goal data shapes.
 */
export function extractStateFromJsonLd(rawState: unknown): string | undefined {
	if (typeof rawState === 'string' && rawState.length > 0) {
		return rawState;
	}
	if (typeof rawState === 'object' && rawState !== null) {
		const name = (rawState as Record<string, unknown>).name;
		if (typeof name === 'string' && name.length > 0) {
			return name;
		}
	}
	return undefined;
}
